import { ChangeDetectorRef, Component } from "@angular/core";
import { ChannelRepository } from "app/js/src/domain/channel-repository";
import {
  ContentControlLiveSource,
  ContentControlLiveSourceType,
} from 'app/js/src/domain/content-control/live-source';

@Component({
  selector: "evrideo-content-control-opertation-room-assets-manager",
  templateUrl:
    "./content-control-opertation-room-assets-manager.component.html",
  styleUrl: "./content-control-opertation-room-assets-manager.component.scss",
})
export class ContentControlOpertationRoomAssetsManagerComponent {
  searchTerm = "";
  channelsSources: Array<ContentControlLiveSource> = [];
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private channelRepository: ChannelRepository,
  ) {}
  ngOnInit() {
    this.channelRepository.getTenantChannels().then((channels) => {
      for (const channel of channels) {
        if (channel.isActive) {
          this.channelsSources.push(
            new ContentControlLiveSource(
              channel.uid,
              channel.name,
              ContentControlLiveSourceType.Channel,
              channel.previewUrls.find((x) => x.name === "Auto")?.url || "",
              channel.placeholderImage || "",
            ),
          );
        }
      }
      this.changeDetectorRef.markForCheck();
    });
    this.changeDetectorRef.markForCheck();
  }
}
